import i18nInstance from 'i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, '@mc/next')

export const getDurationDaysGuestPass = (durationDays: number) =>
  durationDays === 1
    ? t('faq.guestPass.aux.hoursDuration', {
        duration: 24,
      })
    : t('faq.guestPass.aux.daysDuration', {
        duration: durationDays,
      })
